import { render, staticRenderFns } from "./giftCurrencyLog.vue?vue&type=template&id=298847c5&scoped=true"
import script from "./giftCurrencyLog.vue?vue&type=script&lang=js"
export * from "./giftCurrencyLog.vue?vue&type=script&lang=js"
import style0 from "./giftCurrencyLog.vue?vue&type=style&index=0&id=298847c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298847c5",
  null
  
)

export default component.exports